import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'PEDIDO_OCORRENCIA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('pedidoOcorrenciaForm', registro)
    ];
}

export function getLista(idPedido) {
    const request = axios.get(`${consts.API_URL}/pedidoOcorrencia?id_pedido=${idPedido}`);
    return {
        type: 'PEDIDO_OCORRENCIA_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/pedidoOcorrencia`, {
				...registro,
				pedido_item: (registro.pedido_item || []).map(item => ({
					...item,
					datahora_previsao_entrega: DateFormat.formatarDataHoraTelaParaSql(item.datahora_previsao_entrega)
				})),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.id_pedido));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/pedidoOcorrencia`, {
				...registro,
				pedido_item: (registro.pedido_item || []).map(item => ({
					...item,
					datahora_previsao_entrega: DateFormat.formatarDataHoraTelaParaSql(item.datahora_previsao_entrega)
				})),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.id_pedido));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/pedidoOcorrencia?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista(registro.id_pedido));
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}